module.exports = __webpack_public_path__ + "media/application/images/ui/icon-menu-hamburger-c1e04723ea9906d8ba7e8aca356bf5ff.svg";